import $ from 'jquery'

import { makeMeSticky } from './../../utils/domHelpers'

$(document).on('turbolinks:load', function () {
  makeMeSticky('[data-behaviour="fixed-pageheader"]', 50)
  return $(
    "[data-behaviour~='account-mapping-name'], [data-behaviour~='account-mapping-number']"
  ).change((_event) => Silverfin.Dirty.setDirty())
})

onDomLoad(($dom) =>
  $dom.on('focus', 'table td .select2', function (e) {
    if (e.originalEvent) {
      return $(this).siblings('select').select2('open')
    }
  })
)

$(document).on(
  'click',
  '[data-behaviour~="account-mapping-list-submit"]',
  function (event) {
    event.stopPropagation()

    const $form = $('form[data-behaviour~="account-mapping-table"]')

    let allMapped = true
    $("[data-behaviour~='account-mapping-number']").each(function () {
      if ($(this).val() === null || $(this).val().length === 0) {
        allMapped = false
        return
      }
    })

    if (allMapped) {
      return $form.submit()
    }

    return window.sfConfirm({
      question: I18n.t('js.confirm.are_you_sure'),
      confirmLabel: I18n.t('js.global_confirmation_modal.default.confirm'),
      cancelLabel: I18n.t('js.global_confirmation_modal.default.cancel'),
      message: I18n.t('js.account_mapping.unmapped_warning_submit'),
      onConfirm: () => {
        return $form.submit()
      },
      options: {
        confirm_variant: 'primary',
        message_class: 'sf-c-primary-darker sf-bg-primary-subtle',
      },
    })
  }
)

onDomLoad(($dom) =>
  $.fn.select2.amd.require(
    ['select2/data/array', 'select2/utils'],
    function (ArrayData, Utils) {
      const CustomData = function ($element, options) {
        CustomData.__super__.constructor.call(this, $element, options)
      }

      Utils.Extend(CustomData, ArrayData)

      CustomData.prototype.query = function (params, callback) {
        // id == number (using id here because that's how select2 calls it)
        const $mappingTable = $(this.$element).parents(
          '[data-behaviour="account-mapping-table"]'
        )
        const allIds = $mappingTable.data('usedNumbersNotOnPage').slice()
        const accountMappings = $mappingTable.data('account-mappings')
        const automaticSuffixes = $mappingTable.data('automaticSuffixes')

        const allNames = []
        const currentId = this.$element.val()

        $("[data-behaviour~='account-mapping-number']").each(function () {
          if ($(this).val() !== currentId) {
            if (($(this).val() || '').length > 0) {
              return allIds.push($(this).val())
            }
          }
        })

        const lowerCaseQuery = (params.term || '').toLowerCase()

        const filteredResults = []

        for (const accountMapping of Array.from(accountMappings)) {
          if (filteredResults.length >= 50) {
            break
          }

          // if the number is already used/selected
          if ($.inArray(accountMapping.id, allIds) !== -1) {
            continue
          }

          // an account with the same name is regarded as the same account, so don't show it
          // this allows to define lots of accounts with the same name, but we'll only
          // show the first hit
          if (
            accountMapping.name &&
            $.inArray(accountMapping.name, allNames) !== -1
          ) {
            continue
          }

          const result = (() => {
            if (lowerCaseQuery.length === 0) {
              return true
            } else {
              const lowercaseFullName = accountMapping.text
                .toLowerCase()
                .replace(/\u00A0/g, ' ')
              if ($.isNumeric(lowerCaseQuery[0])) {
                return lowercaseFullName.indexOf(lowerCaseQuery) === 0
              } else {
                return lowercaseFullName.indexOf(lowerCaseQuery) > -1
              }
            }
          })()

          if (result) {
            allNames.push(accountMapping.name)
            filteredResults.push(
              nextAvailableAccountWithSuffix(
                accountMapping,
                automaticSuffixes,
                allIds
              )
            )
          }
        }

        return callback({ results: filteredResults })
      }

      return $dom
        .find('[data-behaviour="account-mapping-table"]')
        .each(function () {
          const accountMappings = $(this).data('account-mappings')
          const locales = $(this).data('locales')
          const useOriginalNames = $(this).data('originalNames')

          $.each(accountMappings, function () {
            this.name = this[`name_${I18n.locale}`]
            return initMappingFromNumber(this, this.number)
          })

          return $(this)
            .find("[data-behaviour~='account-mapping-number']")
            .select2({
              dataAdapter: CustomData,
              allowClear: true,
              placeholder: '',
              dropdownCssClass: 'account-mapping-dropdown',
              initSelection($element, callback) {
                return callback({ id: $element.val(), text: $element.val() })
              },
            })
            .on('select2:select', function (event) {
              const $tr = $(this).closest('tr')
              $tr
                .find("[data-behaviour~='account-mapping-type']")
                .val(event.params.data.account_type)

              const $warning = $tr.find(
                "[data-behaviour~='account-type-warning']"
              )
              if (
                majorAccountTypeChange(
                  $warning.data('current-account-type'),
                  event.params.data.account_type
                )
              ) {
                $warning.removeClass('sf-hidden')
              } else {
                $warning.addClass('sf-hidden')
              }

              return (() => {
                const result = []
                for (const locale of Array.from(locales)) {
                  const $input = $tr.find(
                    `[data-behaviour~='account-mapping-name-${locale}']`
                  )
                  if (useOriginalNames) {
                    result.push($input.val($input.data('proposed')))
                  } else {
                    result.push($input.val(event.params.data[`name_${locale}`]))
                  }
                }
                return result
              })()
            })
            .on('select2:unselect', function (_event) {
              const $tr = $(this).closest('tr')
              $tr.find("[data-behaviour~='account-mapping-type']").val('')
              $tr
                .find("[data-behaviour~='account-type-warning']")
                .addClass('sf-hidden')
              return (() => {
                const result = []
                for (const locale of Array.from(locales)) {
                  const $input = $tr.find(
                    `[data-behaviour~='account-mapping-name-${locale}']`
                  )
                  result.push($input.val($input.data('proposed')))
                }
                return result
              })()
            })
            .on('select2:close', function () {
              return $(this)
                .parents('tr')
                .find("input[type='text']:first")
                .focus()
            })
        })
    }
  )
)

const majorAccountTypeChange = function (oldAccountType, newAccountType) {
  if (!oldAccountType || !newAccountType) {
    return false
  }
  return (
    ['income', 'expense'].includes(oldAccountType) ^
    ['income', 'expense'].includes(newAccountType)
  )
}

const nextAvailableAccountWithSuffix = function (
  accountMapping,
  automaticSuffixes,
  allIds
) {
  if (automaticSuffixes) {
    for (const suffix of Array.from(automaticSuffixes)) {
      const accountNumberWithSuffix = `${accountMapping.id}${suffix}`
      if ($.inArray(accountNumberWithSuffix, allIds) === -1) {
        accountMapping = Object.assign({}, accountMapping)
        initMappingFromNumber(accountMapping, accountNumberWithSuffix)
        return accountMapping
      }
    }
  } else {
    return accountMapping
  }
}

const initMappingFromNumber = function (accountMapping, accountNumber) {
  accountMapping.id = accountNumber
  return (accountMapping.text = accountMapping.name
    ? `${accountNumber} ${accountMapping.name}`
    : accountNumber)
}
